export default "__VITE_PUBLIC_ASSET__3b76b57c__"